import {
  AllInvoices,
  PaymentActivityInvoice,
} from '@payments/services/file-handler-payments.service';
import { b64toBlob } from '@shared/helpers/file.helpers';
import { desiredColumn } from '@shared/models/desired-column';
import { SeperatedColumn } from '@shared/models/seperated-columns';
import { CellObject, ColInfo, utils, write } from 'xlsx';

export const excelToBlob = (
  fileName: string,
  seperatedColumns: SeperatedColumn[],
  columnConfig: desiredColumn[],
  invoices: PaymentActivityInvoice[],
) => {
  const headers = seperatedColumns.map(column => column.columnName);

  const worksheet = utils.json_to_sheet(invoices, {
    header: [
      'customerName',
      'customerNumber',
      'documentDate',
      'primaryTransactionNumber',
      'primaryTransactionType',
      'secondaryTransactionNumber',
      'secondaryTransactionType',
      'referenceNumber',
      'paymentMethod',
      'paidAmount',
      'paymentDate',
      'access',
    ],
    sheetStubs: true,
  });
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet);

  const columnWidths: ColInfo[] = headers.map((header, index) => {
    const width = columnConfig[index].cellWidth || 10;
    return { wch: Math.max(header.length, width) };
  });
  worksheet['!cols'] = columnWidths;

  const range = utils.decode_range(worksheet['!ref']);
  columnConfig.forEach((column, index) => {
    for (let i = 0; i <= range.e.r; i++) {
      const cellAddress = utils.encode_cell({ c: index, r: i });
      const cell: CellObject = worksheet[cellAddress];
      if (!!cell && !!column.cellType) {
        cell.t = column.cellType;
      }
      if (!!cell && !!column.cellFormat) {
        cell.z = column.cellFormat;
      }
    }
  });

  utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

  const data = write(workbook, { compression: true, type: 'base64' });
  return b64toBlob(data);
};

export const allInvoiceExcelToBlob = (
  seperatedColumns: SeperatedColumn[],
  columnConfig: desiredColumn[],
  invoices: AllInvoices[],
  showOrderNumber: boolean,
) => {
  const headers = seperatedColumns.map(column => column.columnName);
  const worksheet = utils.json_to_sheet(invoices, {
    header: [
      'customerName',
      'customerNumber',
      'primaryTransactionType',
      'primaryTransactionNumber',
      'secondaryTransactionType',
      'secondaryTransactionNumber',
      'customerPO',
      ...(showOrderNumber ? ['orderNumber'] : []),
      'dateIssued',
      'amount',
      'amountDue',
      'dueDate',
      'status',
    ],
    sheetStubs: true,
  });
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet);

  const columnWidths: ColInfo[] = headers.map((header, index) => {
    const width = columnConfig[index].cellWidth || 10;
    return { wch: Math.max(header.length, width) };
  });
  worksheet['!cols'] = columnWidths;

  const range = utils.decode_range(worksheet['!ref']);
  columnConfig.forEach((column, index) => {
    for (let i = 0; i <= range.e.r; i++) {
      const cellAddress = utils.encode_cell({ c: index, r: i });
      const cell: CellObject = worksheet[cellAddress];
      if (!!cell && !!column.cellType) {
        cell.t = column.cellType;
      }
      if (!!cell && !!column.cellFormat) {
        cell.z = column.cellFormat;
      }
    }
  });

  utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

  const data = write(workbook, { compression: true, type: 'base64' });
  return b64toBlob(data);
};
